module.exports = __webpack_public_path__ + "static/media/feather-webfont.cc5143b2.eot";